export default "__VITE_PUBLIC_ASSET__8b995302__"